<div id="vgn-globalHeader" attr.data-vgn-source="{{content | json}}"></div>
